export const logoTitle = {
  nl: ['Technisch', 'Installatiebedrijf'],
  eng: ['Technical', 'Solutions'],
};

export const header = {

  nl: ['Technisch', 'Installatiebedrijf'],
  eng: ['Technical', 'Solutions'],
};

export const home = {

  quotes: {
    nl: [
      'Bij DNZ Projects staan uw wensen centraal tijdens onze uitvoering',
      'Een land in verval, is een land in opkomst',
      'Uw wens, is onze missie',
      'of we vinden een weg, of we maken er één',
    ],
    eng: [
      'these are the english quotes',
      'and another one',
    ],
  },

};

export const vacancies = {

  qoutes: [
    'bij DNZ-Projects geven wij iedereen de ruimte',
  ],

};
